import { encounterServices } from '../services/encounterServices'


export const encounterActions = {
    addEncounter,
    retrieveEncounters,
};

function addEncounter(id, language, dispatch, intl) {
    dispatch(request());

    encounterServices.getEncounterStatus(id, language, intl)
        .then(
            res => {
                dispatch(success(res))
            },
            error => {
                dispatch(failure(error))
            }
        );

    function request(){
        return ({ type : "ENCOUNTER_ADD_REQUEST" });
    }
    function success(encounter){
        return ({ type : "ENCOUNTER_ADD_SUCCESS", encounter });
    }
    function failure(error){
        return ({ type : "ENCOUNTER_ADD_FAILURE", error });
    }
}

function retrieveEncounters(ids, language, dispatch, intl) {
    dispatch(request());

    encounterServices.getEncountersStatus(ids, language, intl)
        .then(
            res => {
                dispatch(success(res))
            },
            error => {
                dispatch(failure(error))
            }
        );

    function request() {
        return ({ type : "ENCOUNTERS_LIST_REQUEST" });
    }
    function success(encounters) {
        return ({ type : "ENCOUNTER_LIST_SUCCESS", encounters });
    }
    function failure(error) {
        return ({ type : "ENCOUNTER_LIST_FAILURE", error });
    }
}